<template>
  <div class="error">
    <div class="header">
      <img
        src="@/assets/images/exclamation-mark-outline.svg"
        width="60"
        height="60"
      />
      <h2>500</h2>
    </div>
    <translate tag="p">
      We are sorry your most recent action has resulted in an error. A notice
      has been sent automatically to our development team and we will fix the
      problem soon.
    </translate>

    <p>
      <i18n-t keypath="If you would like help, please {contactUs}.">
        <template #contactUs>
          <translate tag="a" :href="contactUsLink" target="_blank">
            contact us
          </translate>
        </template>
      </i18n-t>
    </p>

    <br />

    <pu-link path="/">
      <translate>Go to the homepage</translate>
    </pu-link>
    <pu-link path="/campsites/">
      <translate>Search</translate>
    </pu-link>
    <translate tag="a" target="_blank" :href="contactUsLink">
      Contact us
    </translate>
  </div>
</template>

<script lang="ts">
import type { NuxtError } from 'nuxt/app'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Error500 extends Vue {
  @Prop({ type: Object, required: true }) readonly error!: NuxtError

  @Prop({ required: true }) readonly contactUsLink: string
}

export default toNative(Error500)
</script>
